import React from 'react';
import type { InputNode } from '../types';
import { SeTooltip } from './SeTooltip';

type TagNodeProps = {
  node: InputNode;
  hideClose?: boolean;
  onClose?: () => void;
  /** tooltip 浮层 zIndex 覆盖。技能 tag 在面板内时需 > 9999 才不被面板压住 */
  tooltipZIndex?: number;
};

const normalizeTooltip = (tooltip: InputNode['tooltip']): string => {
  if (!tooltip) return '';
  return typeof tooltip === 'string' ? tooltip : JSON.stringify(tooltip);
};

/**
 * V1 真实结构（src/components/RichTextEditor/nodes/tag/render.ts）：
 * <span class="tag-node group" contenteditable="false">
 *   <span class="tag-label">${text}</span>
 *   <span class="tag-close-btn"><svg .../></span>
 * </span>
 */
export const TagNode: React.FC<TagNodeProps> = React.memo(({ node, hideClose, onClose, tooltipZIndex }) => {
  const tooltip = normalizeTooltip(node.tooltip);

  const tagEl = (
    <span
      contentEditable={false}
      className={['tag-node', 'group', node.className].filter(Boolean).join(' ')}
      {...(tooltip ? { 'data-tooltip': tooltip, 'data-tag-key': node.key || '' } : {})}
    >
      <span
        className="tag-label"
        {...(!hideClose && onClose
          ? {
              // 注意：不用 role="button"。消费端（antd/Tailwind 等）常有针对
              // [role="button"] 的全局重置（background:none），会清掉 tag-label 的
              // 渐变 background-clip:text → 配合 transparent fill → 文字彻底不可见。
              // 改用非语义的 data 标记表达「可点击删除」，点击行为靠 onClick 即可。
              'data-tag-clickable': 'true',
              onMouseDown: (e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
              },
              onClick: (e: React.MouseEvent) => {
                e.preventDefault();
                e.stopPropagation();
                onClose();
              },
            }
          : {})}
      >
        {node.text}
      </span>
      {/* {!hideClose && (
        <span
          className="tag-close-btn"
          title="Clear (ESC)"
          role="button"
          aria-label="exit-agent"
          onMouseDown={(e) => {
            e.preventDefault();
            e.stopPropagation();
          }}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onClose?.();
          }}
        >
          <svg
            width="10"
            height="10"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="4"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M18 6L6 18M6 6l12 12" />
          </svg>
        </span>
      )} */}
    </span>
  );

  if (!tooltip) return tagEl;

  return <SeTooltip title={tooltip} zIndex={tooltipZIndex}>{tagEl}</SeTooltip>;
});
TagNode.displayName = 'TagNode';
